import _ from 'lodash';
import { install as subviewPluginInstall, installCompareViewPlugins, installTopViewPlugins, routeAppender, compareRouteAppender, SIDES } from '@/subview_plugins/install';
import SingleView from '../views/entry-view/SingleView';
import SideView from '../views/entry-view/SideView';
import CompareView from '../views/entry-view/CompareView';
import PageNotFound from 'library-@/components/404/Main';
import getParams, { defaultViewPropsGetter } from 'library-@/utils/get-params';
import { ROUTE_NAME_SUBDUAL, ROUTE_NAME_COMPARE } from '@/constants';

window.queryObj = getParams() || {};

subviewPluginInstall();
installCompareViewPlugins();

const routesAppender = installTopViewPlugins();
const routes = [
    ...routesAppender,
    {
        path: `/:${SIDES.LEFT}':${SIDES.RIGHT}`,
        props: { left: defaultViewPropsGetter, right: defaultViewPropsGetter, single: defaultViewPropsGetter },
        components: {
            left: SideView,
            right: SideView,
            single: SingleView,
            compareLeft: CompareView,
            compareRight: CompareView,
        },
        children: [
            {
                name: ROUTE_NAME_SUBDUAL,
                path: '',
                props: { ...routeAppender.props },
                components: {
                    ...routeAppender.components,
                },
                children: [...routeAppender.children],
            },
            {
                name: ROUTE_NAME_COMPARE,
                path: ':leftId\':rightId',
                props: { ...compareRouteAppender.props },
                components: {
                    ...compareRouteAppender.components,
                },
                children: [...compareRouteAppender.children],
            },
        ],
    },
    {
        path: '*',
        component: PageNotFound,
    },
];

export default _.map(routes, route => ({ ...route }));
